import { render, staticRenderFns } from "./UserRegistrationWizard.vue?vue&type=template&id=4818aba2&"
import script from "./UserRegistrationWizard.vue?vue&type=script&lang=js&"
export * from "./UserRegistrationWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports